// Getting things out of the app: share sheet where available, download where not.

import { shareFile, shareUrl, isNative } from './native.js';
import { toast } from './util.js';

export function canvasToBlob(canvas, type = 'image/png', quality) {
  return new Promise((resolve) => canvas.toBlob(resolve, type, quality));
}

/**
 * Share a blob, falling back to a download.
 *
 * Order matters: the native plugin is tried first because it distinguishes a
 * cancelled share from a failed one. Falling straight to a download after the
 * user dismissed the sheet would silently save a file they just declined.
 */
export async function shareOrDownload(blob, filename, title = filename) {
  const nativeResult = await shareFile(blob, filename, title);
  if (nativeResult === 'shared' || nativeResult === 'aborted') return nativeResult;

  if (!isNative && navigator.canShare?.({ files: [new File([blob], filename, { type: blob.type })] })) {
    try {
      await navigator.share({ files: [new File([blob], filename, { type: blob.type })], title });
      return 'shared';
    } catch (e) {
      if (e?.name === 'AbortError') return 'aborted';
    }
  }

  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 10_000);
  return 'downloaded';
}

export async function shareLink(url, title, text) {
  const nativeResult = await shareUrl(url, title, text);
  if (nativeResult) return nativeResult;

  if (navigator.share) {
    try { await navigator.share({ url, title, text }); return 'shared'; }
    catch (e) { if (e?.name === 'AbortError') return 'aborted'; }
  }

  try { await navigator.clipboard.writeText(url); toast('Link copied'); return 'copied'; }
  catch { return null; }
}
